import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Layout from '../layout'
import PageSection from '../page-sections/PageSection'
import GridCardD from '../content-modules/GridCardD'
import CardHandler from '../content-modules/CardHandler'
import RecentPosts from '../page-sections/RecentPosts'
import PromoCardD from '../content-blocks/PromoCardD'
import HeroIntroSection from '../page-sections/HeroIntroSection'
import AllChaptersData from '../collections/AllChapters'
import { stripTrailingSlash } from '../../utils/tools'
import EventList from '../../utils/EventList'
import { allowedParentPage, sortChapterPage } from '../../utils/chapters'

function WordPressGroupPage({ page }) {
    const data = useStaticQuery(graphql`
        query ChapterOptions {
            allWp {
                nodes {
                    siteChapterSettings {
                        chapterHomeFields {
                            affinityGroupText
                            affinityGroupPositioningStatement
                        }
                    }
                }
            }
        }
    `)

    const siteChapterSettings = data.allWp?.nodes
        ? data.allWp.nodes[0].siteChapterSettings
        : null
    const chapterHomeFields = siteChapterSettings?.chapterHomeFields
        ? siteChapterSettings.chapterHomeFields
        : null

    const {
        affinityGroupText,
        affinityGroupPositioningStatement,
    } = chapterHomeFields

    const chapterData = AllChaptersData()

    const thisChapter = chapterData.nodes.find(chapter => {
        let url = chapter?.chapterDetails?.csUrl ?? ''
        return stripTrailingSlash(url) === page.slug
    })

   

    const eventbutton = [
        {
            link: '/events/all',
            text: 'See All WAA Events',
        },
    ]
    const featuredbutton = [
        {
            link: '/news/all',
            text: 'See all news and stories',
        },
    ]
    const { title, link, excerpt, wpChildren, featuredImage, groups } = page

    const imageWidth = featuredImage?.node?.mediaDetails?.width
        ? featuredImage.node.mediaDetails.width
        : null

    const RenderedMenu = wpChildren?.nodes
        ? wpChildren.nodes
              .filter(allowedParentPage)
              .sort(sortChapterPage)
              .map(item => (
                  <PromoCardD
                      key={item.id}
                      title={item.title}
                      url={item.uri}
                      isNav
                  />
              ))
        : null


    const resolvedStatement = affinityGroupPositioningStatement
    const events = new EventList(groups?.nodes[0]?.events.nodes, { sort: true })
    const eventsToShow = events.getList()

    const social = thisChapter?.chapterDetails ? thisChapter : null
    return (
        <Layout title={title} url={link} img={featuredImage?.node}>
            <PageSection
                heading={title}
                excerpt={affinityGroupText}
                withSocial={social}
                plainText
                pageTitle
                groupPage>
                <div
                    className="groupPage"
                    dangerouslySetInnerHTML={{ __html: resolvedStatement }}
                />
            </PageSection>
            <div
                style={{
                    maxWidth: `1080px`,
                    margin: `auto`,
                    paddingBottom: `58px`,
                }}>
                {featuredImage?.node && (
                    <HeroIntroSection
                        heroImage={featuredImage.node.localFile}
                        heroSize="slim"
                        variant="white"
                        excerpt={excerpt}
                        imageWidth={imageWidth}
                    />
                )}
                {!featuredImage && <PageSection excerpt={excerpt} />}
            </div>
            {RenderedMenu && (
                <PageSection popOut>
                    <GridCardD groupmenu>{RenderedMenu}</GridCardD>
                </PageSection>
            )}

            {eventsToShow.length > 0 && (
                <PageSection
                    id="upcoming-events"
                    heading="Upcoming Events"
                    topBorder
                    buttons={eventbutton}>
                    <CardHandler items={eventsToShow} size="M" type="event" />
                </PageSection>
            )}

            <PageSection
                heading="WAA Stories"
                buttons={featuredbutton}
                topBorder>
                <RecentPosts />
            </PageSection>
        </Layout>
    )
}

export default WordPressGroupPage
